import { Skeletons } from "../../../../components/molecules";
import { Empty, Loading } from "../../../../foundation";
import { Table, TableCard } from "@introist/react-foundation/v2";
import { DatasetEntry } from "../../hooks/useDataset";
import { useDatasetFields } from "../../hooks/useDatasetFields";

// A dataset's field data can itself contain a field named "id" (e.g. a source record's
// own id), which would collide with and silently clobber the entry's real id if both
// were merged under the same "id" key. Use a key no dataset field path can realistically
// produce, and spread it last so the entry's real id always wins regardless.
const ENTRY_ID_KEY = "__datasetEntryId";

export const DatasetTable = ({
  datasetId,
  entries,
  onClick
}: {
  datasetId: string;
  entries?: DatasetEntry[];
  onClick?: (entryId: string) => unknown;
}) => {
  const { fields } = useDatasetFields({ datasetId });

  return (
    <Loading
      data={entries}
      loading={<Skeletons.List />}
      empty={<Empty title="No entries" icon="list" />}
    >
      <TableCard>
        <Table
          onClick={e => onClick && onClick(e[ENTRY_ID_KEY])}
          rowHeightRem={4}
          columns={(fields?.slice(0, 3) ?? []).map((f, i) => ({
            key: f.key,
            title: f.title,
            sortable: true,
            bold: i === 0
          }))}
          data={(entries ?? []).map(e => ({ ...e.data, [ENTRY_ID_KEY]: e.id }))}
        />
      </TableCard>
    </Loading>
  );
};
